import { getConsultationBaseUrl } from "~/providers/utils";
import { api } from "./axios";

export interface PaymentIntentResponse {
  amount: number;
  client_secret: string;
  provider_publishable_key: string;
}

export interface ConfigStripeKeysResponse {
  publishableKey: string;
}

export const createPaymentIntent = async (consultationId?: string) => {
  const { data } = await api.post<PaymentIntentResponse>(
    `${getConsultationBaseUrl(consultationId)}/payments/payment-intent`,
    {},
  );

  return { data };
};

export const confirmPayment = async ({
  paymentId,
  consultationId,
}: {
  paymentId: string;
  consultationId?: string;
}) => {
  const { data } = await api.post<null>(
    `${getConsultationBaseUrl(consultationId)}/payments/${paymentId}/confirm`,
    {},
  );

  return { data };
};
